import { useEffect } from 'react';

export const useScrollToTopOfStepperPage = () => {
  useEffect(() => {
    const nodeToScroll = document.getElementsByClassName('dash-stepper-body')[0];
    nodeToScroll && nodeToScroll.scroll({ top: 0, behavior: 'smooth' });
  }, []);
};
